import { render, staticRenderFns } from "./EWTrxActivityTypeForm.vue?vue&type=template&id=d3b38c88&"
import script from "./EWTrxActivityTypeForm.vue?vue&type=script&lang=js&"
export * from "./EWTrxActivityTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports